// Очистка/восстановление показателей обеспечения при переключении галочек
// "обеспечение на всё тело долга" (UF_IS_ALL_ZAIM_PR / UF_IS_ALL_ZAIM_PR2 /
// UF_SETTING.UF_IS_ALL_ZAIM_PR_AO) на шаге "Обеспечение".
//
// При установке галочки поля видов обеспечения, которые блокируются (становятся
// серыми), очищаются — чтобы они не учитывались системой и валидация требовала
// заполнить нужные поля (БГ/МСП/ВЭБ/РГО/ЭКСАР). При снятии галочки ранее
// введённые значения восстанавливаются (в рамках текущего просмотра шага).
//
// Компонент обязан определить метод isMainCoverBlockedByAllZaim(dir), точно
// повторяющий условие :disabled поля "Объем обеспечения" в своём шаблоне. При
// необходимости можно переопределить isZalogBlockedByAllZaim().
export default {
  data() {
    return {
      allZaimBackup: { main: {}, zalog: {} }
    };
  },
  methods: {
    // Вид обеспечения относится к поручительствам (отдельная верстка строк).
    isPoruchitelstvoDir(dir) {
      return (
        dir.CODE === "poruchitelstvo" ||
        dir.CODE === "poruchitelstvo_international_financial_organizations" ||
        dir.CODE === "poruchitelstva-control-org"
      );
    },
    // По умолчанию залоги полностью блокируются основной галочкой.
    isZalogBlockedByAllZaim() {
      return this.project.UF_IS_ALL_ZAIM_PR == 1;
    },
    // ID залогов, которые относятся к блоку "Виды дополнительного обеспечения"
    // (транспортные средства, CODE === "transport2"). Эти строки не блокируются
    // галочкой и НЕ должны очищаться при её установке.
    getDopObespZalogIds() {
      const ids = [];
      const tree = this.directory && this.directory.tree_zalogi;
      if (!tree) return ids;
      tree.forEach(function(node) {
        if (!node.CHILD) return;
        node.CHILD.forEach(function(child) {
          if (child.CODE === "transport2") ids.push(String(child.ID));
        });
      });
      return ids;
    },
    // Очистка/восстановление одного поля с сохранением исходного значения.
    syncAllZaimField(store, key, field, item, blocked, emptyVal) {
      if (blocked) {
        if (typeof store[key] === "undefined") store[key] = {};
        if (typeof store[key][field] === "undefined") {
          store[key][field] = item[field];
        }
        item[field] = emptyVal;
      } else if (store[key] && typeof store[key][field] !== "undefined") {
        item[field] = store[key][field];
        delete store[key][field];
        if (Object.keys(store[key]).length === 0) delete store[key];
      }
    },
    // Очищает "лишние" показатели при установке галочки и возвращает их при снятии.
    applyAllZaimClearing() {
      const backup = this.allZaimBackup;
      // Основное обеспечение.
      this.getProcurings().forEach(function(dir) {
        const items = this.project.MAIN_COVER.items[dir.ID];
        if (!items) return;
        const blocked = this.isMainCoverBlockedByAllZaim(dir);
        // Поручительства (строки с ОГРН, class="ogrn") при блокировке галочкой
        // не просто очищаются, а удаляются целиком. Восстановление при снятии
        // галочки не предусмотрено (деструктивно).
        if (blocked && this.isPoruchitelstvoDir(dir)) {
          items.splice(0, items.length);
          return;
        }
        items.forEach(function(item, ind) {
          const key = dir.ID + "_" + ind;
          this.syncAllZaimField(
            backup.main,
            key,
            "UF_JUR_FACE",
            item,
            blocked,
            ""
          );
          this.syncAllZaimField(
            backup.main,
            key,
            "UF_OBJEM_VALUE",
            item,
            blocked,
            0
          );
          this.syncAllZaimField(
            backup.main,
            key,
            "UF_OBJEM_DISCONT_VAL",
            item,
            blocked,
            0
          );
        }, this);
      }, this);
      // Залоги.
      const zalogBlocked = this.isZalogBlockedByAllZaim();
      const dopObespZalogIds = this.getDopObespZalogIds();
      if (this.project.ZALOG && this.project.ZALOG.items) {
        Object.keys(this.project.ZALOG.items).forEach(function(id) {
          // Строки блока "Виды дополнительного обеспечения" (transport2) не
          // сбрасываем — они не блокируются галочкой.
          if (dopObespZalogIds.indexOf(String(id)) >= 0) return;
          const items = this.project.ZALOG.items[id];
          if (!items) return;
          items.forEach(function(item, ind) {
            const key = id + "_" + ind;
            this.syncAllZaimField(backup.zalog, key, "UF_JUR_FACE", item, zalogBlocked, "");
            this.syncAllZaimField(backup.zalog, key, "UF_OBJEM_VALUE", item, zalogBlocked, 0);
            this.syncAllZaimField(backup.zalog, key, "UF_OBJEM_DISCONT_VAL", item, zalogBlocked, 0);
            this.syncAllZaimField(backup.zalog, key, "UF_VID_TR_ID", item, zalogBlocked, "");
            this.syncAllZaimField(backup.zalog, key, "UF_TYPE_FACE_ZL_ID", item, zalogBlocked, "");
            this.syncAllZaimField(backup.zalog, key, "UF_NAME_FACE_ZALOG", item, zalogBlocked, "");
            this.syncAllZaimField(backup.zalog, key, "UF_VID_BONDS_ID", item, zalogBlocked, "");
            this.syncAllZaimField(backup.zalog, key, "UF_HAVINGS", item, zalogBlocked, "");
          }, this);
        }, this);
      }
    },
    onChangeAllZaim() {
      this.applyAllZaimClearing();
      this.$parent.updateAllSumPercent();
    },
    onChangeAllZaim2() {
      this.applyAllZaimClearing();
      this.$parent.updateAllSumPercent2();
    },
    onChangeAllZaimAO() {
      this.applyAllZaimClearing();
    }
  }
};
